import { createHash } from "crypto";

/**
 * Instrumentation TEMPORAIRE pour l'incident CU-86cbdr1k6 (tempête de refresh
 * post-MEP Next 16 → re-logins → saturation du rate limiter).
 *
 * Activée uniquement quand la variable d'environnement AUTH_DIAG === "1"
 * (positionnable/retirable sur upsun sans redéploiement). À supprimer une fois
 * l'investigation terminée.
 *
 * Lecture des logs : `upsun log app --app club_app | grep AUTH-DIAG`
 * IMPORTANT : on ne loggue jamais de token/refresh_token/mot de passe en clair,
 * seulement un hash court pour corréler une même session entre les lignes.
 */
export const authDiagEnabled = (): boolean => process.env.AUTH_DIAG === "1";

/** Hash court non réversible d'un secret, pour corrélation seulement. */
export const shortHash = (value?: string | null): string => {
  if (!value) return "none";
  return createHash("sha256").update(value).digest("hex").slice(0, 12);
};

/** Émet une ligne de log préfixée, lisible dans les logs upsun de club_app. */
export const logAuthDiag = (message: string): void => {
  console.warn(`[AUTH-DIAG] ${message}`);
};
